<h1 mat-dialog-title>Inserisci un nome per l'Analisi Scenario</h1>
<div mat-dialog-content>
    <mat-form-field appearance="fill">
        <mat-label>Nome</mat-label>
        <input matInput [formControl]="analisiScenarioName">
    </mat-form-field>
</div>
<div mat-dialog-actions>
    <button mat-button (click)="cancel()">Annulla</button>
    <button mat-button (click)="confirm()">Conferma</button>
</div>